/**
 * The app icon a person picks: four colourways of the arch, one shape.
 *
 * The web draws it as the tab's favicon. The desktop app draws its own dock
 * icon and offers the same four in its app menu, so the web picker hides
 * there. A home-screen icon is fixed when it is installed, so it stays Paper.
 *
 * Kept per browser in `localStorage`: it is a convenience, not an account
 * setting, and a blocked store only means the default comes back.
 */
export const APP_ICONS = [
  { id: 'paper', label: 'Paper' },
  { id: 'rust', label: 'Rust' },
  { id: 'sand', label: 'Sand' },
  { id: 'terracotta', label: 'Terracotta' },
] as const;

export type AppIconId = (typeof APP_ICONS)[number]['id'];

const KEY = 'agora.app-icon';

export function savedAppIcon(): AppIconId {
  try {
    const id = localStorage.getItem(KEY);
    return APP_ICONS.find((icon) => icon.id === id)?.id ?? 'paper';
  } catch {
    return 'paper';
  }
}

export function applyAppIcon(id: AppIconId, save = true) {
  const link = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
  if (link) link.href = `/icons/${id}.svg`;
  if (!save) return;
  try {
    localStorage.setItem(KEY, id);
  } catch {}
}
